<template>
    <section class="columns noprint">
        <div class="scfForm">
            <div class="campusForm">
                <div>
                    <div>
                        <fieldset class="scfSectionBorderAsFieldSet">
                            <legend class="scfSectionLegend">
                                {{ model.title }}
                            </legend>
                            <div class="scfSectionContent">

                                <div class="scfRadioButtonListBorder">
                                    <span class="scfRadioButtonListLabel">
                                        {{ getTranslation('camp_edu_AddressType') }}
                                    </span>
                                    <div class="scfRadioButtonListGeneralPanel">
                                        <table class="scfRadioButtonList">
                                            <tr>
                                                <td>
                                                    <input id="typePrivatGeschaeft_0" type="radio" name="typePrivatGeschaeft_group" value="p" v-model="model.typePrivatGeschaeft" />
                                                    <label for="typePrivatGeschaeft_0">{{ getTranslation('camp_edu_AddressTypeP') }}</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input id="typePrivatGeschaeft_1" type="radio" name="typePrivatGeschaeft_group" value="g" v-model="model.typePrivatGeschaeft" />
                                                    <label for="typePrivatGeschaeft_1">{{ getTranslation('camp_edu_AddressTypeG') }}</label>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                                <div class="scfDropListBorder">
                                    <label for="gender" class="scfDropListLabel">
                                        {{ getTranslation('camp_Gender') }} *
                                    </label>
                                    <div class="scfDropListGeneralPanel">
                                        <select id="gender" class="scfDropList regular-drop-down" v-model="model.gender">
                                            <option value="">{{ getTranslation('camp_GenderChoose') }}</option>
                                            <option value="f">{{ getTranslation('camp_GenderFemale') }}</option>
                                            <option value="m">{{ getTranslation('camp_GenderMale') }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="firstName" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_FirstName') }} *
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="firstName" type="text" v-model="model.firstName" maxlength="100" class="scfSingleLineTextBox" required />
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="lastName" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_LastName') }} *
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="lastName" type="text" v-model="model.lastName" maxlength="100" class="scfSingleLineTextBox" required />
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder" v-if="model.typePrivatGeschaeft === 'g'">
                                    <label for="firma" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_Firma') }} *
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="firma" type="text" v-model="model.firma" maxlength="100" class="scfSingleLineTextBox" />
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder" v-if="model.typePrivatGeschaeft === 'g'">
                                    <label for="abteilung" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_Abteilung') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="abteilung" type="text" v-model="model.abteilung" maxlength="100" class="scfSingleLineTextBox" />
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="strasse" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_Strasse') }} *
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="strasse" type="text" v-model="model.strasse" maxlength="100" class="scfSingleLineTextBox" required />
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="postfach" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_Adresszusatz') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="postfach" type="text" v-model="model.postfach" maxlength="100" class="scfSingleLineTextBox" />
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="plz" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_PLZ') }} *
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="plz" type="text" v-model="model.plz" maxlength="20" class="scfSingleLineTextBox" required />
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="ort" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_Ort') }} *
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="ort" type="text" v-model="model.ort" maxlength="100" class="scfSingleLineTextBox" required />
                                    </div>
                                </div>

                                <div class="scfDropListBorder">
                                    <label for="country" class="scfDropListLabel">
                                        {{ getTranslation('camp_edu_Land') }} *
                                    </label>
                                    <div class="scfDropListGeneralPanel">
                                        <select id="country" class="scfDropList regular-drop-down" v-model="model.country">
                                            <option v-for="option in model.countries" v-bind:value="option.value">
                                                {{ option.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </fieldset>
                    </div>
                </div>

                <div class="scfFooterBorder">
                    <p></p>
                </div>

                <div class="scfSubmitButtonBorder">
                    <input type="submit" :value="getTranslation('camp_edu_Save')" @click.prevent="save" class="scfSubmitButton" />
                    <a href="../" class="button">{{ getTranslation('camp_Cancel') }}</a>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
    import MyCampusStudMeineDaten from "../../../_Api/MyCampusStudMeineDaten";

    export default {
        data() {
            return {
                "model": {
                    "title": null,
                    "typeKorrespondenzRechnung": null,
                    "typePrivatGeschaeft": null,
                    "gender": null,
                    "firstName": null,
                    "lastName": null,
                    "firma": null,
                    "abteilung": null,
                    "strasse": null,
                    "postfach": null,
                    "plz": null,
                    "ort": null,
                    "country": null,
                    "countries": null,
                    "translations": null
                },
                "additional": {
                    "redirectUrl": null
                }
            }
        },
        created() {
            let data = this.$parent.$data;
            this.model = data.model;
            this.additional = data.additional;
        },
        methods: {
            save() {
                if (!this.model.gender
                    || !this.model.firstName
                    || !this.model.lastName
                    || !this.model.strasse
                    || !this.model.plz
                    || !this.model.ort) {
                    var msg = this.getTranslation('camp_RequiredFieldMessageBox');
                    dialogError(msg);
                    return;
                }
                var query = {
                    "typeKoRe": this.model.typeKorrespondenzRechnung,
                    "typePrGe": this.model.typePrivatGeschaeft,
                    "gender": this.model.gender,
                    "firstName": this.model.firstName,
                    "lastName": this.model.lastName,
                    "firma": this.model.firma,
                    "abteilung": this.model.abteilung,
                    "strasse": this.model.strasse,
                    "postfach": this.model.postfach,
                    "plz": this.model.plz,
                    "ort": this.model.ort,
                    "country": this.model.country
                };
                MyCampusStudMeineDaten.updateAddress(query, this.saveSuccess, this.saveFailure);
            },
            getTranslation(key) {
                return this.model.translations[key];
            },
            saveSuccess(data) {
                if (data.successful) {
                    window.location = this.additional.redirectUrl;
                }
                else {
                    dialogError(data.message);
                }
            },
            saveFailure(status) {
                dialogError("Es ist ein Fehler aufgetreten: Status-Code " + status);
            }
        }
    }
</script>
<style scoped lang="scss">
@import "~/Assets/Campus/Common/sass/colors";
    .regular-drop-down {
        border: 1px solid $black;
        border-radius: 0px;
        color: $black;
        padding: 0.2rem 0.5rem;
        height: 2.5rem;
    }
</style>